import { render, staticRenderFns } from "./DrivePublic.vue?vue&type=template&id=3a3c5f2b&scoped=true&"
import script from "./DrivePublic.vue?vue&type=script&lang=js&"
export * from "./DrivePublic.vue?vue&type=script&lang=js&"
import style0 from "./DrivePublic.vue?vue&type=style&index=0&id=3a3c5f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3c5f2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3c5f2b')) {
      api.createRecord('3a3c5f2b', component.options)
    } else {
      api.reload('3a3c5f2b', component.options)
    }
    module.hot.accept("./DrivePublic.vue?vue&type=template&id=3a3c5f2b&scoped=true&", function () {
      api.rerender('3a3c5f2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/drive/DrivePublic.vue"
export default component.exports